import * as React from 'react';
import styled from 'styled-components';
import cl from 'classnames';

import { fillStyles } from './fillStyles';
import { outlineStyles } from './outlineStyles';
import { transparentStyles } from './transparentStyles';

const Container = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  cursor: pointer;
  user-select: none;

  ${fillStyles}
  ${outlineStyles}
  ${transparentStyles}
`;

export const ButtonStyles = props => {
  const {
    buttonStyle = 'filled',
    color,
    colorStyle,
    content,
    onClick,
    disabled = false,
    loading = false
  } = props;

  return (
    <Container
      className={cl(
        'button-styles',
        buttonStyle,
        `color-${color}`,
        `
        color-style-${colorStyle}`,
        { disabled, loading }
      )}
      onClick={e => !disabled && onClick?.(e)}
    >
      {content}
    </Container>
  );
};
